// MenuItem.js
import React, { memo } from "react"
import { NavLink } from "react-router-dom"

const MenuItem = ({ path, icon, label }) => {
  return (
    <li>
      <NavLink to={path} activeclassname="active">
        <span className="material-icons">{icon}</span>
        {label}
      </NavLink>
    </li>
  )
}

// Export component wrapped in memo to prevent unnecessary renders
export default memo(MenuItem)
